import React from 'react';
import { getPinNodeExist, getSpiceModelExist } from "./ErrorCheck";

function getSweepErrorCheck({ expContent, baseContent, libraryInfo }) {
  //The settings in the default base are fine
  //Sweep's error check
  //1. Check the data in the pin and check if there are any pins that have not set the model, etc
  //2. Association between simulation config and pin settings
  // pdnWorstScenario，numberBits，isStatEye
  let currentConfig = {};
  if (baseContent && baseContent.config && baseContent.config.option && baseContent.config.option.simConfig) {
    currentConfig = { ...baseContent.config.option.simConfig }
  }
  if (expContent && expContent.config && expContent.config.option && expContent.config.option.simConfig) {
    let statEyeConfig = currentConfig.statEyeConfig
    if (expContent.config.option.simConfig.statEyeConfig && Object.keys(expContent.config.option.simConfig.statEyeConfig).length) {
      statEyeConfig = { ...statEyeConfig, ...expContent.config.option.simConfig.statEyeConfig }
    }
    currentConfig = { ...currentConfig, ...expContent.config.option.simConfig, statEyeConfig }
  }

  const pdnWorstScenario = currentConfig && currentConfig.pdnWorstScenario ? currentConfig.pdnWorstScenario : false;
  //  //pdnWorstScenario check stimulus If PRBS
  const numberBits = currentConfig && currentConfig.statEyeConfig && currentConfig.statEyeConfig.numberBits ? currentConfig.statEyeConfig.numberBits : 0;
  const isStatEye = currentConfig && currentConfig.simulateMode && currentConfig.simulateMode === "StatEye";
  let runType = expContent.config && expContent.config.runType ? expContent.config.runType : baseContent.config && baseContent.config.runType ? baseContent.config.runType : "";
  let includePdn = baseContent.config.includePdn;

  let error = []

  baseContent.content.forEach(interfaceListInfo => {
    const currentInterfaceList = expContent.content.find(item => item.id === interfaceListInfo.id)
    const content = interfaceListInfo.content ? interfaceListInfo.content : interfaceListInfo.Interfaces || []
    const currentInterfaceListContent = currentInterfaceList.content ? currentInterfaceList.content : currentInterfaceList.Interfaces || []
    const mergePin = getMergePins(content);
    const currentMergePins = getMergePins(currentInterfaceListContent);
    const errorList = getInterfaceError(mergePin, currentMergePins, { includePdn, runType, pdnWorstScenario, numberBits, isStatEye }, libraryInfo)
    if (errorList && errorList.length) {
      error.push(<p style={{ margin: 0 }}>-------------{interfaceListInfo.name}-------------</p>)
      error.push(...errorList)
    }
  })
  return error;
}

function getMergePins(content) {
  let mergePins = []
  for (let interfaceInfo of content) {
    const pins = interfaceInfo.pins || [];
    for (let pin of pins) {
      const { component, pinInfo = [] } = pin;

      const findIndex = mergePins.findIndex(item => item.component === component);
      if (findIndex > -1) {
        mergePins[findIndex].pinInfo.push(...pinInfo)
      } else {
        mergePins.push({ component, pinInfo: JSON.parse(JSON.stringify(pinInfo)) })
      }
    }
  }
  return mergePins
}

function getInterfaceError(BaseInterfacePins = [], interfaceListPins = [], config, libraryInfo) {
  let error = []
  const pinsList = [...BaseInterfacePins] || [];
  const { runType, includePdn, pdnWorstScenario, numberBits, isStatEye } = config;
  const { spiceList, onDieSpiceList, ibisList, ibisAmiList, vectorList } = libraryInfo
  const ICs = [...pinsList]
  if (ICs.length > 0) {
    ICs.forEach(comp => {
      const currentCompInfo = interfaceListPins.find(item => item.component === comp.component)
      const componentName = comp.component;
      const ignoreBitsErrorPins = new Map();
      const useIbisAmiPins = [];
      let useIbisAmi = false;

      comp.pinInfo.forEach(pin => {
        const currentCompInfoPinInfo = currentCompInfo && currentCompInfo.pinInfo ? currentCompInfo.pinInfo : []
        const currentPin = currentCompInfoPinInfo.find(item => item.pin === pin.pin && item.usage === pin.usage) || {}
        const model = currentPin && currentPin.model ? { ...pin.model, ...currentPin.model } : { ...pin.model };
        const pinModels = currentPin && currentPin.pinModels && currentPin.pinModels.length ? [...currentPin.pinModels] : pin.pinModels ? [...pin.pinModels] : [];
        const powerOff = currentPin && currentPin.powerOff ? currentPin.powerOff : pin.powerOff ? pin.powerOff : '';
        const usageType = pin.usage.toLowerCase()
        if (model && model.libType === 'SPICE' && model.fileName) {
          let { modelExist, libraryList } = getSpiceModelExist([...spiceList, ...onDieSpiceList], model);
          if (!modelExist) {
            const fileExist = libraryList.find(spice => spice.name === model.fileName);
            const text = fileExist ? "updated" : 'deleted';
            error.push(<p style={{ margin: 0 }}>{pin.usage} "<span className="font-bold">{componentName}/{pin.pin}</span>" spice file {model.folder ? `${model.folder}::` : ""}{model.fileName} has been {text}.</p>)
          }
        } else if (model && model.libType === 'IBIS' && model.fileName) {
          let modelExist = ibisList.find(ibis => ibis.id === model.libraryId && ibis.name === model.fileName)
            || ibisAmiList.find(ibis => ibis.children && ibis.children.find(it => it.id === model.libraryId && it.name === model.fileName));
          if (!modelExist) {
            const fileExist = ibisList.find(ibis => ibis.name === model.fileName);
            const text = fileExist ? "updated" : 'deleted';
            error.push(<p style={{ margin: 0 }}>{pin.usage} "<span className="font-bold">{componentName}/{pin.pin}</span>" IBIS file {model.fileName} has been {text}.</p>)
          }
        } else if (model && model.libType === 'IBIS_AMI' && model.fileName) {
          if (!isStatEye) {
            if (!useIbisAmiPins.includes(pin.pin)) {
              useIbisAmiPins.push(pin.pin);
            }
            useIbisAmi = true;
          }
        }

        // pinModel
        if (pinModels && pinModels.length > 0) {
          //When using pattern sweep for the SEV project, there is no need to set pinModels
          const ND_PU = pinModels.find(item => item.pinName === "nd_pu");
          const ND_PD = pinModels.find(item => item.pinName === "nd_pd");

          if (model && model.libType === 'SPICE' && !model.folder) {//folder does not require pu/pd voltage
            if (!ND_PU.voltage) {
              error.push(<p style={{ margin: 0 }}>"<span className="font-bold">{componentName}/{pin.pin} {usageType}</span>" model V_PU is not set.</p>)
            }

            if (!ND_PD.voltage) {
              error.push(<p style={{ margin: 0 }}>"<span className="font-bold">{componentName}/{pin.pin} {usageType}</span>" model V_PD is not set.</p>)
            }
          } else if (model && model.libType === 'IBIS') {
            if (powerOff === '1') {
              if (!ND_PU.voltage) {
                error.push(<p style={{ margin: 0 }}>"<span className="font-bold">{componentName}/{pin.pin} {usageType}</span>" model V_PU is not set.</p>)
              }

              if (!ND_PD.voltage) {
                error.push(<p style={{ margin: 0 }}>"<span className="font-bold">{componentName}/{pin.pin} {usageType}</span>" model V_PD is not set.</p>)
              }
            }
          }
          if (pin.usage === 'Driver') {
            const ND_IN = pinModels.find(item => item.pinName === "nd_in");
            let inputStimulus = null, vector = null;
            inputStimulus = ND_IN && ND_IN.type ? ND_IN.type : "";
            vector = ND_IN ? ND_IN : "";

            if (!inputStimulus) {
              error.push(<p style={{ margin: 0 }}>"<span className="font-bold">{componentName}/{pin.pin}</span>" stimulus is not set.</p>)
            }
            if (inputStimulus === 'VEC') {
              if (!vector.stimulus || Object.keys(vector.stimulus).length === 0 || !vector.stimulus.fileName) {
                error.push(<p style={{ margin: 0 }}>"<span className="font-bold">{componentName}/{pin.pin}</span>" stimulus vector is not set.</p>)
              } else {
                const stimulusModel = vector.stimulus;
                if (stimulusModel) {
                  let modelExist = vectorList.find(vec => vec.id === stimulusModel.libraryId && vec.name === stimulusModel.fileName);
                  if (!modelExist) {
                    error.push(<p style={{ margin: 0 }}>"<span className="font-bold">{componentName}/{pin.pin}</span>" vector file {stimulusModel.fileName} not exist.</p>)
                  }
                }
              }
            }
          }
        }

        //  run type
        if ((['ALL', "Read"].includes(runType) || !runType)
          && (!model || (model && !model.modelName) || (model && model.libType === "SPICE" && model.folder && getPinNodeExist(model, usageType, includePdn)))) {
          error.push(<p style={{ margin: 0 }}>"<span className="font-bold">{componentName}/{pin.pin} {usageType}</span>" model is not set.</p>)
        }

        //  pdnWorstScenario
        if (pdnWorstScenario) {
          const targetSignal = /^(CA|DQ|DM)/.test(pin.signal) && !pin.signal.includes("DQS");
          if (usageType === 'driver') {
            const ifPRBS = pinModels.length > 2 && pinModels[2].type.startsWith("PRBS");
            if (targetSignal && !ifPRBS) {
              const stimulusType = pinModels[2].type;
              error.push(<p style={{ margin: 0 }}>"<span className="font-bold">{componentName}-{pin.pin}</span>" stimulus model type {stimulusType} is not support in PDN Worst Scenario.</p>)
            }
          }
        }

        //check ami number bits and ignoreBits
        if (isStatEye && pin.amiModelInfo && pin.amiModelInfo.amiParameters) {
          let amiIgnoreBits = pin.amiModelInfo.amiParameters.find(item => item.name === "Ignore_Bits") || {};
          if (currentPin.amiModelInfo && currentPin.amiModelInfo.amiParameters) {
            const _amiIgnoreBits = currentPin.amiModelInfo.amiParameters.find(item => item.name === "Ignore_Bits") || {};
            if (_amiIgnoreBits) {
              amiIgnoreBits = _amiIgnoreBits
            }
          }
          if (amiIgnoreBits) {
            const amiIgnoreBitsValue = amiIgnoreBits.value ? parseInt(amiIgnoreBits.value) : 0;
            if (amiIgnoreBitsValue > numberBits) {
              const ignoreBitsPins = ignoreBitsErrorPins.get(amiIgnoreBitsValue) || [];
              ignoreBitsErrorPins.set(amiIgnoreBitsValue, [...ignoreBitsPins, pin.pin]);
            }
          }
        }
      })
      //check ami number bits and ignoreBits
      if (isStatEye && ignoreBitsErrorPins.size) {
        for (const [key, value] of ignoreBitsErrorPins.entries()) {
          const _value = [...new Set([...value])]
          error.push(<p style={{ margin: 0 }}>The AMI parameter 'Ignore_Bits'({key}) for <span className="font-bold">{componentName}-[{_value.join(",")}]</span> exceeds the configured 'Number of Bits' in the simulation options.</p>)
        }
        error.push(<p style={{ margin: 0 }}>To resolve this mismatch, either set a longer 'Number of Bits' in the simulation settings or a shorter 'Ignore_Bits' parameter in the AMI configuration.</p>)
      }
      if (!isStatEye && useIbisAmi) {
        error.push(<p style={{ margin: 0 }}><span className="font-bold">{componentName}-[{useIbisAmiPins.join(",")}]</span> use IBIS_AMI buffer, please switch simulator type to StatEye.</p>)
      }
    })
  }
  return error
}

export {
  getSweepErrorCheck,
}

